// src/ui/Button.jsx
import React from "react";
import clsx from "clsx";

export default function Button({
  as: Comp = "button",
  variant = "primary",
  slide = false,
  className,
  children,
  disabled,
  loading,
  ...props
}) {
  const base =
    "inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium " +
    "transition-all duration-150 focus:outline-none focus:ring-2 " +
    "focus:ring-[var(--mudo-primary)] disabled:opacity-60 disabled:cursor-not-allowed";

  const variants = {
    primary:
      "bg-[var(--mudo-primary)] text-[var(--mudo-onPrimary)] shadow-sm " +
      "hover:shadow-md hover:-translate-y-0.5 active:translate-y-0",
    secondary:
      "bg-transparent border border-[var(--mudo-border)] text-[var(--mudo-text)] " +
      "hover:bg-[var(--mudo-bg-soft)]",
    soft:
      "bg-[var(--mudo-primary-soft)] text-[var(--mudo-text)] border border-[var(--mudo-border)] " +
      "hover:bg-[color-mix(in_lab,var(--mudo-primary-soft),transparent_10%)]",
    ghost:
      "bg-transparent text-[var(--mudo-text)] border border-transparent " +
      "hover:bg-[color-mix(in_lab,var(--mudo-bg-soft),transparent_20%)]",
    danger:
      "bg-red-600 text-white hover:bg-red-700",
  };

  const contentClass = slide ? "relative overflow-hidden inline-flex items-center" : "";
  const innerClass = slide ? "transition-transform group-hover:translate-x-1" : "";

  return (
    <Comp
      className={clsx("group", base, variants[variant] || variants.primary, className)}
      disabled={disabled || loading}
      {...props}
    >
      <span className={contentClass}>
        <span className={innerClass}>{loading ? "…" : children}</span>
      </span>
    </Comp>
  );
}
